import { render, staticRenderFns } from "./RecommendBetNumListView.vue?vue&type=template&id=d67389a0&scoped=true"
import script from "./RecommendBetNumListView.vue?vue&type=script&lang=js"
export * from "./RecommendBetNumListView.vue?vue&type=script&lang=js"
import style0 from "./RecommendBetNumListView.vue?vue&type=style&index=0&id=d67389a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67389a0",
  null
  
)

export default component.exports